const JournalSummary = ({
    invoice
}) => {
    let journal_summary = invoice?.statement?.journal_summary;
    if(typeof journal_summary === 'undefined'){
        journal_summary = invoice?.journal_summary;
    }
    
    if (typeof journal_summary === 'undefined'){
        return null;
    }

    const journalEntries = Object.entries(journal_summary);
    return (
        <>
        <br />
        <h4 className="text-center" style={{border:'1px solid #ccc'}}>Invoice Summary</h4>
        <br />
        <div>
            <table style={{width: '100%'}}>
                <tbody>       
                    {journalEntries.map(([key, value]) => {
                        if (typeof value === 'object') {
                            return Object.entries(value).map(([subKey, subValue]) => (
                                Number(subValue) !== 0 &&(<tr key={subKey}>
                                    <td >{subKey}</td>
                                    <td style={{textAlign:'right'}}>${Number(subValue).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                                </tr>)
                            ));
                        }
                        return null;
                    })}

                    <tr>
                        <td style={{ paddingTop: '8px', borderTop: 'thin black dotted'}} ><b>Total
                                Charges</b></td>
                        <td style={{textAlign:'right', paddingTop: '8px', borderTop: 'thin black dotted'}}
                          ><b>${Number(journal_summary?.grand_total).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b></td>
                    </tr>
                </tbody>
            </table>
        </div>
        </>
    )
}
export default JournalSummary